import axios from "axios";
import ApiErrors from "../utilities/ApiErrors";

export default {
  async login(datos) {
    delete axios.defaults.headers.common["Authorization"];

    try {
      const { data } = await axios({
        url: `/auth/login`,
        data: datos,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async me() {
    try {
      const { data } = await axios({ url: `/usuarios/me/`, method: "GET" });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async get(opciones) {
    const pagina = opciones.page ?? 0;
    const cantidad = opciones.rows ?? 5000;
    const sort_nombre = opciones.sortField ?? "id";
    const sort_orden = opciones.sortOrder ?? 1;
    const filtro = opciones.filters?.global?.value ?? "";
    const nivel = opciones.nivel ?? 0;
    const cliente_id = opciones.cliente_id ?? 0;
    const proveedor_id = opciones.proveedor_id ?? 0;
    const borrados = opciones.borrados ?? false;
    const full_info = opciones.full_info ?? false;

    try {
      const { data } = await axios({
        url: `/usuarios/?nivel=${nivel}&cliente_id=${cliente_id}&proveedor_id=${proveedor_id}&pagina=${pagina}&cantidad=${cantidad}&sort_nombre=${sort_nombre}&sort_orden=${sort_orden}&filtro=${filtro}&borrados=${borrados}&full_info=${full_info}`,
        method: "GET",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async getVencimientos(dias,tiempo) {
    try {
      const { data } = await axios({
        url: `/usuarios/vencimientos/?dias=${dias}&tiempo=${tiempo}`,
        method: "GET",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async add(usuarioNuevo) {
    try {
      const { data } = await axios({
        url: `/usuarios/`,
        data: usuarioNuevo,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async addMultiple(usuariosNuevos) {
    try {
      const { data } = await axios({
        url: `/usuarios/multiple`,
        data: usuariosNuevos,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async update(usuarioActualizado) {
    try {
      const { data } = await axios({
        url: `/usuarios/${usuarioActualizado.id}`,
        data: usuarioActualizado,
        method: "PUT",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async delete(usuarioId) {
    try {
      await axios({ url: `/usuarios/${usuarioId}`, method: "DELETE" });
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async reset(datosReset) {
    try {
      const { data } = await axios({
        url: `/auth/reset`,
        data: datosReset,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async passwordTemporal(datosPasswordTemporal) {
    try {
      const { data } = await axios({
        url: `/usuarios/password_temporal`,
        data: datosPasswordTemporal,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async resetPassword(datosResetPassword) {
    try {
      const { data } = await axios({
        url: `/auth/reset_password`,
        data: datosResetPassword,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },
};
